/* AUG theme scripts */
(function () {
  'use strict';

  /* ---- ヘッダーのメガパネル開閉 ---- */
  function initPanel() {
    var burger = document.querySelector('[data-aug-burger]');
    var panel = document.querySelector('[data-aug-panel]');
    if (!burger || !panel || burger.dataset.augBound) return;
    burger.dataset.augBound = '1';

    var overlay = document.querySelector('[data-aug-overlay]');

    /* v485：スマホでメニューを開いたとき、ヘッダーをそのまま残すための下ごしらえ。

       メニューはヘッダーの下から出します（CSS は aug-v408.css の 10-40）。
       ヘッダーの下端は、そのときの画面の状態で変わります。
         ・ページの先頭 … お知らせ帯のぶんだけ下にある
         ・少し下げたあと … ヘッダーが画面の上に貼り付いている
       決め打ちにすると、どちらかで隙間や重なりが出てしまうため、
       開いた瞬間と、開いているあいだのスクロール中に実測して
       --aug-hd-b に入れます。CSS 側には 84px の控えを書いてあります。 */
    var hdEl = document.querySelector('[data-aug-header]');

    function syncHeaderBottom() {
      if (!hdEl) return;
      var b = hdEl.getBoundingClientRect().bottom;
      if (b < 0) b = 0;
      document.documentElement.style.setProperty('--aug-hd-b', Math.round(b) + 'px');
    }

    var syncQueued = false;
    function queueSync() {
      if (syncQueued) return;
      syncQueued = true;
      window.requestAnimationFrame(function () {
        syncQueued = false;
        if (document.body.classList.contains('aug-drawer-open')) syncHeaderBottom();
      });
    }

    window.addEventListener('scroll', queueSync, { passive: true });
    window.addEventListener('resize', queueSync, { passive: true });

    function setOpen(open, focusFirst) {
      var focusWasInside = panel.contains(document.activeElement);

      /* 位置を先に決めてから開く（開いてから測ると1コマぶん飛んで見えるため） */
      if (open) syncHeaderBottom();
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      burger.setAttribute('aria-label', open ? 'メニューを閉じる' : 'メニューを開く');
      panel.classList.toggle('is-open', open);
      if (overlay) overlay.classList.toggle('is-open', open);
      document.body.classList.toggle('aug-drawer-open', open);

      if (open) {
        panel.removeAttribute('hidden');
        panel.removeAttribute('inert');
        panel.setAttribute('aria-hidden', 'false');
        if (focusFirst) {
          window.requestAnimationFrame(function () {
            if (burger.getAttribute('aria-expanded') !== 'true' || panel.hasAttribute('inert')) return;
            var first = panel.querySelector('.aug-panel__link');
            if (first) first.focus({ preventScroll: true });
          });
        }
      } else {
        panel.setAttribute('inert', '');
        panel.setAttribute('aria-hidden', 'true');
        if (focusWasInside) burger.focus({ preventScroll: true });
      }
    }

    panel.setAttribute('inert', '');
    panel.setAttribute('aria-hidden', 'true');
    burger.setAttribute('aria-label', 'メニューを開く');
    syncHeaderBottom();

    if (overlay) {
      overlay.addEventListener('click', function () {
        setOpen(false);
      });
    }

    burger.addEventListener('click', function (e) {
      setOpen(burger.getAttribute('aria-expanded') !== 'true', e.detail === 0);
    });

    var closeBtn = panel.querySelector('[data-aug-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        setOpen(false);
      });
    }

    /* ＋ で開く折りたたみ */
    var accs = panel.querySelectorAll('[data-aug-acc]');
    for (var a = 0; a < accs.length; a++) {
      (function (btn) {
        btn.addEventListener('click', function () {
          var sub = btn.parentNode.querySelector('.aug-panel__sub');
          if (!sub) return;
          var open = btn.getAttribute('aria-expanded') === 'true';
          btn.setAttribute('aria-expanded', open ? 'false' : 'true');
          if (open) {
            sub.setAttribute('hidden', '');
          } else {
            sub.removeAttribute('hidden');
          }
        });
      })(accs[a]);
    }

    /* 現在地を含む折りたたみは最初から開いておく */
    var openCurrent = panel.querySelector('.aug-panel__sub .is-current');
    if (openCurrent) {
      var row = openCurrent.closest('.aug-panel__row');
      if (row) {
        var t = row.querySelector('[data-aug-acc]');
        var s = row.querySelector('.aug-panel__sub');
        if (t && s) {
          t.setAttribute('aria-expanded', 'true');
          s.removeAttribute('hidden');
        }
      }
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setOpen(false);
    });

    document.addEventListener('click', function (e) {
      if (burger.getAttribute('aria-expanded') !== 'true') return;
      if (burger.contains(e.target) || panel.contains(e.target)) return;
      setOpen(false);
    });
  }

  /* ---- スクロールしてもヘッダーを上に残す ---- */
  function initStickyHeader() {
    var hd = document.querySelector('[data-aug-header]');
    var spacer = document.querySelector('[data-aug-spacer]');
    if (!hd || hd.dataset.augStick) return;
    hd.dataset.augStick = '1';

    var top = 0;
    var height = 0;
    var fixed = false;

    function measure() {
      if (fixed) return;
      var rect = hd.getBoundingClientRect();
      top = rect.top + (window.pageYOffset || document.documentElement.scrollTop);
      height = rect.height;
      if (spacer) spacer.style.height = height + 'px';
    }

    function onScroll() {
      var y = window.pageYOffset || document.documentElement.scrollTop;
      var next = y > top;
      if (next === fixed) return;
      fixed = next;
      hd.classList.toggle('is-fixed', fixed);
      if (spacer) spacer.classList.toggle('is-on', fixed);
    }

    measure();
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      if (fixed) {
        fixed = false;
        hd.classList.remove('is-fixed');
        if (spacer) spacer.classList.remove('is-on');
      }
      measure();
      onScroll();
    });
    window.addEventListener('load', measure);
  }

  /* ---- 最近チェックした製品 ----
     v459で作り直し。これまでの作りには、スマートフォンで動かなくなる原因が3つあった。

     1. 記録も表示も、init() の中で他の処理のあとに呼ばれていた。
        途中のどれか1つがエラーになると、そこで止まって記録まで届かない。
        → init() の各処理を1つずつ切り離した（下の init を参照）。
     2. 表示するカードを、1枚ずつサーバーに取りに行っていた。
        通信が失敗したり、ボット確認の画面が返ってきたりすると、1枚も作れず枠ごと出ない。
        → 商品ページを開いた時点で、名前・写真・価格まで保存しておき、通信なしで組み立てる。
     3. 保存先が localStorage だけだった。
        Safariの設定によっては使えないことがある。
        → 使えないときは Cookie に保存する。
  ---- */
  var RV_KEY = 'aug_recently_viewed';
  var RV_MAX = 8;

  function rvReadRaw() {
    try {
      var v = localStorage.getItem(RV_KEY);
      if (v) return v;
    } catch (e) {}
    var m = document.cookie.match(/(?:^|;\s*)aug_rv=([^;]*)/);
    if (m) {
      try { return decodeURIComponent(m[1]); } catch (e) {}
    }
    return '';
  }

  function rvWriteRaw(str) {
    var ok = false;
    try {
      localStorage.setItem(RV_KEY, str);
      ok = true;
    } catch (e) {}
    if (!ok) {
      try {
        document.cookie = 'aug_rv=' + encodeURIComponent(str) + '; path=/; max-age=2592000; SameSite=Lax; Secure';
      } catch (e) {}
    }
  }

  function rvSafeProductUrl(raw, handle) {
    var fallback = '/products/' + encodeURIComponent(String(handle || ''));
    try {
      var url = new URL(String(raw || fallback), window.location.origin);
      if (url.origin !== window.location.origin || url.pathname.indexOf('/products/') !== 0) return fallback;
      return url.pathname + url.search + url.hash;
    } catch (e) {
      return fallback;
    }
  }

  function rvSafeImageUrl(raw) {
    if (!raw) return '';
    try {
      var url = new URL(String(raw), window.location.origin);
      var trustedShopifyCdn = url.hostname === 'cdn.shopify.com' || url.hostname === 'cdn.shopifycdn.net';
      if (url.protocol !== 'https:' || (url.origin !== window.location.origin && !trustedShopifyCdn)) return '';
      return url.href;
    } catch (e) {
      return '';
    }
  }

  function rvList() {
    var list = [];
    try {
      list = JSON.parse(rvReadRaw() || '[]');
    } catch (e) {
      list = [];
    }
    if (!Array.isArray(list)) return [];
    /* 昔の形（URL名だけの文字列）は名前も写真も持っていないので捨てる。
       次にその商品を開いたときに、新しい形で入り直す。 */
    return list.filter(function (it) {
      return it && typeof it === 'object' && it.h && it.t;
    });
  }

  function recordView() {
    var wrap = document.querySelector('[data-aug-recently-viewed]');
    if (!wrap) return;
    var handle = wrap.getAttribute('data-current-handle') || '';
    var title = wrap.getAttribute('data-current-title') || '';
    if (!handle || !title) return;

    var item = {
      h: handle,
      t: title,
      u: rvSafeProductUrl(wrap.getAttribute('data-current-url'), handle),
      i: rvSafeImageUrl(wrap.getAttribute('data-current-image')),
      c: wrap.getAttribute('data-current-code') || '',
      p: wrap.getAttribute('data-current-price') || '',
      a: wrap.getAttribute('data-current-ask') === '1' ? 1 : 0
    };

    var list = rvList().filter(function (it) {
      return it.h !== handle;
    });
    list.unshift(item);
    rvWriteRaw(JSON.stringify(list.slice(0, RV_MAX)));
  }

  function rvEscape(s) {
    return String(s || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function rvCard(it) {
    var productUrl = rvSafeProductUrl(it.u, it.h);
    var imageUrl = rvSafeImageUrl(it.i);
    var img = imageUrl
      ? '<img src="' + rvEscape(imageUrl) + '" alt="' + rvEscape(it.t) + '" loading="lazy" width="400" height="400">'
      : '';
    var price = it.a
      ? '<p class="aug-card__price aug-card__price--ask">価格はお問い合わせください</p>'
      : '<p class="aug-card__price">' + rvEscape(it.p) + '</p>';
    return (
      '<a class="aug-card" data-aug-card href="' + rvEscape(productUrl) + '">' +
      '<div class="aug-card__img">' + img + '</div>' +
      '<p class="aug-card__code">' + (it.c ? rvEscape(it.c) : '&nbsp;') + '</p>' +
      '<p class="aug-card__ttl">' + rvEscape(it.t) + '</p>' +
      price +
      '</a>'
    );
  }

  function renderRecentlyViewed() {
    var wrap = document.querySelector('[data-aug-recently-viewed]');
    if (!wrap) return;
    var grid = wrap.querySelector('[data-aug-rv-grid]');
    if (!grid) return;

    var current = wrap.getAttribute('data-current-handle') || '';
    var list = rvList()
      .filter(function (it) {
        return it.h !== current;
      })
      .slice(0, 5);

    if (!list.length) return;

    grid.innerHTML = list.map(rvCard).join('');
    wrap.removeAttribute('hidden');
  }

  /* ---- ヒーロースライダー ---- */
  function initHero() {
    var hero = document.querySelector('[data-aug-hero]');
    if (!hero || hero.dataset.augBound) return;
    hero.dataset.augBound = '1';
    var slides = hero.querySelectorAll('[data-aug-slide]');
    var dots = hero.querySelectorAll('.aug-hero__dot');
    if (slides.length < 2) return;
    var i = 0, timer = null;
    var interval = (parseInt(hero.getAttribute('data-interval'), 10) || 6) * 1000;
    var auto = hero.getAttribute('data-autoplay') !== 'false';

    var track = hero.querySelector('.aug-hero__track');

    function show(n) {
      i = (n + slides.length) % slides.length;
      for (var k = 0; k < slides.length; k++) slides[k].classList.toggle('is-active', k === i);
      for (var d = 0; d < dots.length; d++) dots[d].classList.toggle('is-active', d === i);
      // 名称付きナビも現在地を合わせる
      var tabs = hero.parentNode ? hero.parentNode.querySelectorAll('[data-aug-hero-tab]') : [];
      for (var t = 0; t < tabs.length; t++) {
        var on = Number(tabs[t].getAttribute('data-aug-hero-tab')) === i;
        tabs[t].classList.toggle('is-current', on);
        tabs[t].setAttribute('aria-selected', on ? 'true' : 'false');
      }
      /* 中央のスライドが真ん中に来るように、左右に前後が覗く位置までずらす */
      if (track && slides[i]) {
        var w = slides[i].offsetWidth;
        var offset = slides[i].offsetLeft - (hero.clientWidth - w) / 2;
        track.style.transform = 'translateX(' + -offset + 'px)';
      }
    }
    function start() { if (auto) { stop(); timer = setInterval(function () { show(i + 1); }, interval); } }
    function stop() { if (timer) clearInterval(timer); timer = null; }

    for (var d = 0; d < dots.length; d++) {
      (function (btn) {
        btn.addEventListener('click', function () {
          show(parseInt(btn.getAttribute('data-index'), 10));
          start();
        });
      })(dots[d]);
    }
    // 自動送りを止められるようにする（見づらい人のための手当て）
    var pauseBtn = hero.parentNode ? hero.parentNode.querySelector('[data-aug-hero-pause]') : null;
    if (pauseBtn) {
      pauseBtn.addEventListener('click', function () {
        var stopped = pauseBtn.getAttribute('aria-pressed') === 'true';
        pauseBtn.setAttribute('aria-pressed', stopped ? 'false' : 'true');
        pauseBtn.classList.toggle('is-paused', !stopped);
        if (stopped) {
          start();
        } else {
          stop();
        }
      });
    }

    // OSで「動きを減らす」にしている人には自動送りをしない
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      stop();
      if (pauseBtn) {
        pauseBtn.setAttribute('aria-pressed', 'true');
        pauseBtn.classList.add('is-paused');
      }
    }

    // 名称をクリックしてもスライドを切り替えられるようにする
    var heroTabs = hero.parentNode ? hero.parentNode.querySelectorAll('[data-aug-hero-tab]') : [];
    for (var t2 = 0; t2 < heroTabs.length; t2++) {
      (function (btn) {
        btn.addEventListener('click', function () {
          show(Number(btn.getAttribute('data-aug-hero-tab')));
        });
      })(heroTabs[t2]);
    }

    var prevBtn = hero.querySelector('[data-aug-hero-prev]');
    var nextBtn = hero.querySelector('[data-aug-hero-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { show(i - 1); start(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { show(i + 1); start(); });

    /* 左右に見えている前後のスライドを押したら、その面に移動する */
    for (var sIdx = 0; sIdx < slides.length; sIdx++) {
      (function (el, n) {
        el.addEventListener('click', function (e) {
          if (n === i) return;
          e.preventDefault();
          show(n);
          start();
        }, true);
      })(slides[sIdx], sIdx);
    }

    window.addEventListener('resize', function () { show(i); });
    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);
    show(0);
    start();
  }

  /* ヘッダーの項目にカーソルを乗せると開く大きなメニュー */
  function initMega() {
    var triggers = document.querySelectorAll('[data-aug-megatrigger]');
    if (!triggers.length) return;

    var openId = null;

    for (var m = 0; m < triggers.length; m++) {
      var initialPanel = panelOf(triggers[m].getAttribute('data-aug-megatrigger'));
      if (initialPanel) {
        initialPanel.removeAttribute('hidden');
        initialPanel.setAttribute('aria-hidden', 'true');
      }
    }
    var timer = null;

    function panelOf(id) {
      return document.querySelector('[data-aug-mega="' + id + '"]');
    }

    function close(id) {
      var p = panelOf(id);
      var t = document.querySelector('[data-aug-megatrigger="' + id + '"]');
      if (p) {
        p.classList.remove('is-open');
        p.setAttribute('aria-hidden', 'true');
      }
      if (t) {
        t.classList.remove('is-open');
        var a = t.querySelector('a');
        if (a) a.setAttribute('aria-expanded', 'false');
      }
      if (openId === id) openId = null;
    }

    /* パネルは .aug-hd の直下に置いてあるので、対応する項目の真下に来るよう左位置を合わせる */
    function place(id) {
      var p = panelOf(id);
      var t = document.querySelector('[data-aug-megatrigger="' + id + '"]');
      var hd = document.querySelector('[data-aug-header]');
      if (!p || !t || !hd) return;
      var hdRect = hd.getBoundingClientRect();
      var tRect = t.getBoundingClientRect();
      var w = p.offsetWidth || 308;
      var left = tRect.left - hdRect.left - 14;
      var max = hdRect.width - w - 12;
      if (left > max) left = max;
      if (left < 12) left = 12;
      p.style.left = Math.round(left) + 'px';
    }

    function open(id) {
      if (openId && openId !== id) close(openId);
      var p = panelOf(id);
      var t = document.querySelector('[data-aug-megatrigger="' + id + '"]');
      if (!p) return;
      p.removeAttribute('hidden');
      place(id);
      /* Safariでも確実に開けるよう、レイアウト確定後に同期で表示する */
      void p.offsetWidth;
      p.classList.add('is-open');
      p.setAttribute('aria-hidden', 'false');
      if (t) {
        t.classList.add('is-open');
        var a = t.querySelector('a');
        if (a) a.setAttribute('aria-expanded', 'true');
      }
      openId = id;
    }

    function scheduleClose(id) {
      clearTimeout(timer);
      timer = setTimeout(function () {
        close(id);
      }, 160);
    }

    function keep() {
      clearTimeout(timer);
    }

    for (var i = 0; i < triggers.length; i++) {
      (function (trigger) {
        var id = trigger.getAttribute('data-aug-megatrigger');
        var panel = panelOf(id);
        if (!panel) return;

        trigger.addEventListener('mouseenter', function () {
          keep();
          open(id);
        });
        trigger.addEventListener('mouseleave', function () {
          scheduleClose(id);
        });
        panel.addEventListener('mouseenter', keep);
        panel.addEventListener('mouseleave', function () {
          scheduleClose(id);
        });

        /* キーボードでも開けるようにする */
        trigger.addEventListener('focusin', function () {
          keep();
          open(id);
        });
        trigger.addEventListener('focusout', function () {
          scheduleClose(id);
        });
        panel.addEventListener('focusin', keep);
        panel.addEventListener('focusout', function () {
          scheduleClose(id);
        });
      })(triggers[i]);
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && openId) close(openId);
    });

    window.addEventListener('resize', function () {
      if (openId) place(openId);
    });
  }

  /* v459：どれか1つがエラーになっても、後ろの処理が止まらないようにする。
     以前は途中で止まると「最近チェックした製品」の記録まで届かなかった。 */
  function safely(fn) {
    try {
      fn();
    } catch (e) {
      if (window.console && console.warn) console.warn('[AUG]', e);
    }
  }

  /* ---- 送信ボタンを押したあとの手ごたえ（v487） ----

     お問い合わせとカタログ請求は、送信すると Shopify のサーバーへ
     ページごと送り直す作りです。返事が返るまでのあいだ画面が変わらないため、
     「送れたのかな」と思ってもう一度押してしまう、という声がありました。
     二重送信になると、同じ問い合わせが2件届きます。

     そこで、押した直後にボタンの文字を「送信中…」に変え、
     それ以上押せないようにします。送信そのものは今までどおりで、
     速くなるわけではありませんが、押した手ごたえは即座に返ります。

     ボタンを使えなくするのは submit の直後（setTimeout 0）にしています。
     押した瞬間に disabled にすると、ブラウザによっては送信自体が
     取り消されてしまうためです。
     必須項目が空でブラウザに止められたときは、何も変えません。 */
  function initFormBusy() {
    var forms = document.querySelectorAll('.aug-ct__form, .aug-catdl__form');
    if (!forms.length) return;

    function submitButton(form) {
      return form.querySelector('button[type="submit"], .aug-ct__submit button, .aug-catdl__submit button');
    }

    /* hCaptcha から戻ったときや、通信を中断したときに送信ボタンを元へ戻す。
       AUG が送信中にしたボタンだけを対象にするため、ほかの disabled は変えない。 */
    function restore(form) {
      var btn = submitButton(form);
      if (!btn || btn.dataset.augBusy !== '1') return;

      if (btn.augBusyTimer) {
        window.clearTimeout(btn.augBusyTimer);
        btn.augBusyTimer = null;
      }
      btn.disabled = false;
      if (typeof btn.augBusyHtml === 'string') btn.innerHTML = btn.augBusyHtml;
      btn.augBusyHtml = null;
      btn.augBusyIntercepted = null;
      delete btn.dataset.augBusy;
      form.classList.remove('is-sending');
    }

    function restoreAll() {
      for (var r = 0; r < forms.length; r++) restore(forms[r]);
    }

    function restoreSoon() {
      var pending = [];
      for (var r = 0; r < forms.length; r++) {
        var btn = submitButton(forms[r]);
        var captcha = forms[r].querySelector('[name="h-captcha-response"]');
        if (btn && btn.dataset.augBusy === '1' && btn.augBusyIntercepted === true && !(captcha && captcha.value)) {
          pending.push(forms[r]);
        }
      }
      if (!pending.length) return;
      window.setTimeout(function () {
        for (var p = 0; p < pending.length; p++) restore(pending[p]);
      }, 500);
    }

    /* 戻る・進むキャッシュ、hCaptcha の取消後のフォーカス復帰、
       オフラインからの復帰を拾う。リスナーはページ内で1度だけ登録する。 */
    if (!window.__augFormBusyRecoveryBound) {
      window.__augFormBusyRecoveryBound = true;
      window.addEventListener('pageshow', restoreAll);
      window.addEventListener('focus', restoreSoon);
      window.addEventListener('online', restoreSoon);
      document.addEventListener('visibilitychange', function () {
        if (!document.hidden) restoreSoon();
      });
    }

    for (var i = 0; i < forms.length; i++) {
      (function (form) {
        if (form.dataset.augBusyBound) return;
        form.dataset.augBusyBound = '1';

        form.addEventListener('submit', function (event) {
          if (typeof form.checkValidity === 'function' && !form.checkValidity()) return;

          var btn = submitButton(form);
          if (!btn || btn.disabled || btn.dataset.augBusy) return;
          btn.dataset.augBusy = '1';
          btn.augBusyHtml = btn.innerHTML;

          form.classList.add('is-sending');
          window.setTimeout(function () {
            if (btn.dataset.augBusy !== '1') return;
            btn.augBusyIntercepted = event.defaultPrevented;
            btn.disabled = true;
            btn.textContent = '送信中…';
          }, 0);

          /* 通信障害などでページ遷移も復帰イベントも起きない場合の安全弁。
             通常の送信はページ遷移するため、このタイマーは実行されない。 */
          btn.augBusyTimer = window.setTimeout(function () {
            restore(form);
          }, 90000);
        });
      })(forms[i]);
    }
  }

  function init() {
    safely(initPanel);
    safely(initMega);
    safely(initStickyHeader);
    safely(initHero);
    safely(initFormBusy);
    safely(recordView);
    safely(renderRecentlyViewed);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
